document.addEventListener("DOMContentLoaded", function() {
    const variantIdInput = document.querySelector('.product-form input[name="id"]');
    const selectedOption = document.querySelectorAll('.product-form__group-option-selected');

    if(typeof variantIdInput != 'undefined' && variantIdInput != null) {
        const variantsJSONDOM = document.querySelector('.product-parameters__variant script');
        const mediaItems = document.querySelectorAll('.grid-gallery .product__media-item');
        const mediaItemsMobile = document.querySelectorAll('.js-media-list-horizontal  .swiper-wrapper > div');

        if(variantsJSONDOM == null) {
            return false;
        }
        const variantsJSON = JSON.parse(variantsJSONDOM.innerText);

        if(mediaItems.length > 0) {
            variantIdInput.addEventListener("change", function(e) {
                filterGallery(mediaItems, mediaItemsMobile, variantsJSON);
                if(typeof selectedOption != 'undefined' && selectedOption != null) {
                    const foundVariantIndex = variantsJSON.findIndex((variant) => variant.id == variantIdInput.value);
                    const foundVariant = variantsJSON[foundVariantIndex];

                    if(selectedOption.length > 0) {
                        selectedOption.forEach(function(element, index) {
                            const indexOption = parseInt(element.dataset.option);
                            element.innerText = foundVariant.options[indexOption];
                        });                        
                    }
                }                
            });
        
            filterGallery(mediaItems, mediaItemsMobile, variantsJSON);
        }
    }   

    function filterGallery(mediaItems, mediaItemsMobile, variantsJSON) {
        const foundVariantIndex = variantsJSON.findIndex((variant) => variant.id == variantIdInput.value);
        const foundVariant = variantsJSON[foundVariantIndex];
        const startMediaPosition = foundVariant.featured_media.position - 1;
        let skipMedia = false, foundMedia = false;
        
        if(typeof foundVariant !== 'undefined' && foundVariant != null) {
            console.log(foundVariant);
            mediaItems.forEach(function(item, index) {
                if(index != startMediaPosition && item.classList.contains('product__media-item--variant') && foundMedia) {
                    skipMedia = true;
                }

                if(!skipMedia) {
                    if(index >= startMediaPosition) {
                        item.classList.add('filter-active');
                        
                        if(!foundMedia) foundMedia = true;
                    } else if (item.classList.contains('filter-active')) {
                        item.classList.remove('filter-active');
                    }
                } else if (item.classList.contains('filter-active')) {
                    item.classList.remove('filter-active');
                }
            });
            
            skipMedia = false;
            foundMedia = false;
            mediaItemsMobile.forEach(function(item, index) {
                if(index != startMediaPosition && item.classList.contains('product__media-item--variant') && foundMedia) {
                    skipMedia = true;
                }

                if(!skipMedia) {
                    if(index >= startMediaPosition) {
                        item.classList.add('filter-active');
                        if(!foundMedia) foundMedia = true;
                    } else if (item.classList.contains('filter-active')) {
                        item.classList.remove('filter-active');
                    }
                } else if (item.classList.contains('filter-active')) {
                    item.classList.remove('filter-active');
                }
            });
        }
    }

    // function filterGallery(mediaItems, mediaItemsMobile, variantsJSON) {
    //     console.log(mediaItemsMobile);
    //     const lastIndex = variantsJSON.length - 1;
    //     const foundVariantIndex = variantsJSON.findIndex((variant) => variant.id == variantIdInput.value);
    //     const foundVariant = variantsJSON[foundVariantIndex];

    //     if(typeof foundVariant !== 'undefined' && foundVariant != null) {
    //         mediaItems.forEach(function(item) {
    //             const dataMediaIdArr = item.dataset.mediaId.split('-');
    //             const dataMediaId = dataMediaIdArr[dataMediaIdArr.length - 1];
    //             if(dataMediaId == foundVariant.featured_media.id) {
    //                 item.classList.add('filter-active');
    //             } else if(item.dataset.filterIndex) {
    //                 const filterIndex = parseInt(item.dataset.filterIndex) ?? 0;
    //                 const filterValue = foundVariant.options[filterIndex].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    //                 if(item.dataset.filterValue == filterValue) {
    //                     item.classList.add('filter-active');
    //                 } else if (item.classList.contains('filter-active')) {
    //                     item.classList.remove('filter-active');
    //                 }
    //             } else if (item.classList.contains('filter-active')) {
    //                 item.classList.remove('filter-active');
    //             }
                
    //         });
            
    //         mediaItemsMobile.forEach(function(item) {
    //             const dataMediaIdArr = item.dataset.mediaId.split('-');
    //             const dataMediaId = dataMediaIdArr[dataMediaIdArr.length - 1];
                
    //             if(dataMediaId == foundVariant.featured_media.id) {
    //                 item.classList.add('filter-active');
    //             } else if(item.dataset.filterIndex) {
    //                 const filterIndex = parseInt(item.dataset.filterIndex) ?? 0;
    //                 const filterValue = foundVariant.options[filterIndex].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    //                 if(item.dataset.filterValue == filterValue) {
    //                     item.classList.add('filter-active');
    //                 } else if (item.classList.contains('filter-active')) {
    //                     item.classList.remove('filter-active');
    //                 }
    //             } else if (item.classList.contains('filter-active')) {
    //                 item.classList.remove('filter-active');
    //             }
    //         });
    //     }
    // };

    setTimeout(function() {
        const redoBox = document.querySelector('#redo-checkbox');
    
        if(typeof redoBox != 'undefined' && redoBox != null) {
            const redoWidget = document.querySelector('redo-shopify-checkbox'); // Replace with actual tag name
            
            if (redoWidget && redoWidget.shadowRoot) {
                console.dir(redoWidget);
                // Find the element inside the shadow root that contains the message
                const message = redoWidget.shadowRoot.querySelector('._6-5'); // Replace with actual class
                const svgCircle = redoWidget.shadowRoot.querySelector('svg circle');
                const svgPath = redoWidget.shadowRoot.querySelector('svg path');
                if (message) {
                    console.log("test");
                    message.style.color = "#808080"; // Use your desired color
                    svgCircle.style.stroke = "#808080"; // Use your desired color
                    svgPath.style.fill = "#808080"; // Use your desired color
                } else {
                    console.log("not found");
                }
            }
        }   
    }, 1400);

    setTimeout(function() {
        const el = document.querySelector('shopify-payment-terms');
        
        const shadow = el.shadowRoot;
        const style = document.createElement('style');
        style.textContent = '#shopify-installments-content,#shopify-installments-cta { font-size: 11px; font-weight: normal; }';
    
        // console.log(shadow);
        shadow.appendChild(style);

        el.classList.add("payments-loaded");
    }, 800);
});